import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ShieldCheck, Check } from 'lucide-react';
export function PurchaseSection() {
  const includes = ['Método Mente y Rendimiento™', 'Recursos de Intervención Deportiva', 'Herramientas Profesionales Aplicables', 'BONUS: Comunicación con el Cuerpo Técnico', 'BONUS: Protocolo de Primera Sesión'];
  return <section className="bg-slate-900 py-12 lg:py-16 relative overflow-hidden" data-id="element-127">
      <div className="absolute inset-0 opacity-10" data-id="element-128">
        <div className="absolute top-1/2 left-1/2 h-[800px] w-[800px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-emerald-500 blur-[100px]" data-id="element-129"></div>
      </div>

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <div className="mx-auto max-w-5xl" data-id="element-131">
          <div id="comprar" className="grid gap-12 lg:grid-cols-2 items-center bg-white rounded-[2.5rem] p-8 md:p-12 shadow-2xl scroll-mt-4" data-id="element-132">
            {/* Left side: Includes */}
            <div data-id="element-133">
              <h3 className="text-2xl font-bold text-slate-900 mb-6 uppercase text-center lg:text-left" data-id="element-134">
                KIT PSICÓLOGO DEPORTIVO
              </h3>
              <ul className="space-y-3" data-id="element-135">
                {includes.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-136">
                    <Check className="h-5 w-5 shrink-0 text-emerald-500 mt-0.5" data-id="element-137" />
                    <span className={`text-slate-700 ${item.includes('BONUS') ? 'font-bold text-amber-600' : 'font-medium'}`} data-id="element-138">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* Right side: Pricing & CTA */}
            <div className="flex flex-col items-center justify-center rounded-3xl bg-slate-50 p-8 border-2 border-emerald-100 text-center h-full" data-id="element-139">
              <div className="mb-2 text-slate-400 font-bold text-2xl line-through decoration-red-500/50 decoration-4" data-id="element-140">
                $49.990 ARS
              </div>
              <div className="mb-8 text-6xl font-black text-slate-900 tracking-tight font-display" data-id="element-141">
                $19.990 <span className="text-3xl text-slate-500" data-id="element-142">ARS</span>
              </div>

              <div className="mb-8 inline-flex items-center gap-2 rounded-full bg-emerald-100 px-4 py-2 text-sm font-bold text-emerald-700" data-id="element-143">
                <ShieldCheck className="h-5 w-5" data-id="element-144" />
                Pago único · Sin cargos ocultos
              </div>

              <Button isFinal={true} className="w-full text-xl py-6 mb-6" data-id="element-145">
                SÍ, QUIERO EL KIT AHORA
              </Button>

              <div className="flex items-center justify-center gap-6 text-sm font-medium text-slate-500" data-id="element-146">
                <div className="flex items-center gap-1.5" data-id="element-147">
                  <Check className="h-4 w-4 text-emerald-500" data-id="element-148" />
                  Acceso inmediato
                </div>
                <div className="flex items-center gap-1.5" data-id="element-149">
                  <ShieldCheck className="h-4 w-4 text-emerald-500" data-id="element-150" />
                  Garantía 7 días
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}